module.exports = __webpack_public_path__ + "media/images/psp/logo-blue-16c111e24299e6f4d6d20963d0c16ef5.svg";